import React, { Component } from 'react';
import { Status } from 'common/utils/constants';
import { IconLoader } from 'common/IconLoader';
import { doBlinkLED, updateLEDStatus } from 'redux/actions';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { connect } from 'react-redux';
import './LEDBar.css';

class LEDBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countingDown: false,
      remainingSeconds: 5
    };

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.reset = this.reset.bind(this);
    this.isOnline = this.isOnline.bind(this);
    this.cleanErrorMessage = this.cleanErrorMessage.bind(this);
  }

  /**
   * Counts down remaining seconds when status is success
   * @param {*} prevState
   */
  componentDidUpdate(prevState) {
    const { status } = this.props;

    if (prevState.status === status && !this.state.countingDown) return;

    if (this.state.remainingSeconds === -1) {
      this.reset();
      return;
    }

    // start counting down
    if (prevState.status === Status.PENDING && status === Status.SUCCESS) {
      this.timer = setInterval(() => {
        this.setState({
          remainingSeconds: this.state.remainingSeconds - 1
        });
      }, 1000);
      this.setState({
        countingDown: true
      });
    }
  }

  /** Resets status and clears time interval if current status is pending/success */
  componentWillUnmount() {
    this.reset();
  }

  /** Resets status and clears time interval created */
  reset() {
    const { deviceID, status } = this.props;

    if (this.timer) clearInterval(this.timer);

    // reset only when "success" to avoid creating multiple pending requests
    if (status === Status.SUCCESS) {
      this.props.dispatch(updateLEDStatus(deviceID, Status.NONE));
    }

    this.setState({
      countingDown: false,
      remainingSeconds: 5
    });
  }

  isOnline() {
    return this.props.connectionState === 'Connected';
  }

  /** Triggers Blink Device LED API */
  handleButtonClick() {
    if (this.props.status !== Status.NONE || !this.isOnline()) return;

    this.props.dispatch(doBlinkLED(this.props.deviceID));
  }

  /** Clean internal error message shown to users */
  cleanErrorMessage(message) {
    if (typeof message === 'string' && message.toLowerCase().includes('unknown error')) {
      return 'Unknown error, please try again in a few minutes';
    }

    return message;
  }

  render() {
    const { status, connectionState, errorMessage, deviceID } = this.props;

    // button Svgs based on different status
    const buttonSvg = [
      <svg className="LEDBar_Svg" width="12" height="12">
        <circle className={`LEDBar_Circle_${connectionState}`} cx="6" cy="6" r="6" />
      </svg>,
      <img className="LEDBar_Svg LEDBar_Loading" width="12" height="12" src={IconLoader.icon_LED_turning} alt=""></img>,
      <svg className="LEDBar_Svg LEDBar_Blinking" width="12" height="12">
        <circle cx="6" cy="6" r="6" />
      </svg>,
      <div className="LEDBar_Svg_Wrapper">
        <svg className="LEDBar_Svg" width="12" height="12">
          <circle cx="6" cy="6" r="6" fill="#ba1f24" />
        </svg>
        <img
          className="LEDBar_Svg LEDBar_Error_White"
          width="12"
          height="12"
          src={IconLoader.icon_error_white}
          alt=""
        ></img>
      </div>
    ];

    const ledMessage = [
      '',
      'Turning on',
      `Turned on successfully, turning off in ${this.state.remainingSeconds} seconds`,
      this.cleanErrorMessage(errorMessage)
    ];

    return (
      <div className="LEDBar_Area">
        <div
          className={`LEDBar_Button LEDBar_Button_${connectionState}`}
          onClick={() => this.handleButtonClick()}
          data-tip={status === Status.NONE && this.isOnline() ? 'Click to turn on LED' : ''}
        >
          {buttonSvg[status]}
          <span
            className={`LEDBar_Button_Text LEDBar_Button_Text_${connectionState} LEDBar_Button_Text_Status_${this.props.status}`}
          >
            LED
          </span>
        </div>
        {this.isOnline() && status !== Status.NONE && (
          <div
            className="LEDBar_Message_Wrapper"
            style={{
              backgroundColor: status === Status.FAILURE ? '#FAF2F2' : ''
            }}
          >
            {status !== Status.NONE && (
              <div className="LEDBar_Message" id={`LEDBar_Message_${status}`}>
                {ledMessage[status]}
              </div>
            )}

            {status === Status.FAILURE ? (
              <div className="LEDBar_Close_X">
                <SvgAF
                  img={IconLoader.icon_close_x}
                  hover={IconLoader.icon_close_x_hover}
                  tooltip={'Close error message'}
                  scaleImg={true}
                  onClick={() => this.props.dispatch(updateLEDStatus(deviceID, Status.NONE))}
                />
              </div>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

export default connect((store, ownProps) => ({
  status: store.statuses['BlinkLED-' + ownProps.deviceID] || Status.NONE,
  errorMessage: store.statuses['BlinkLED-' + ownProps.deviceID + '-ErrorMessage'] || ''
}))(LEDBar);
